import { render, staticRenderFns } from "./QDataTable.vue?vue&type=template&id=9a1dfc4a"
import script from "./QDataTable.vue?vue&type=script&lang=js"
export * from "./QDataTable.vue?vue&type=script&lang=js"
import style0 from "./QDataTable.vue?vue&type=style&index=0&id=9a1dfc4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports